export default class UrlUtils {
  public static urlPath(url: string) {
    return url.replace(/^.*\/\/[^\/]+/, "");
  }

  public static generateNavigationLink(navigationPath : string) {
    return `${window.location.origin}${navigationPath}`
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/UrlUtils.ts